import { Controller } from "stimulus"

// My Point 積分兌換碼輸入列。
// 成功後整頁重載，刻意不做局部更新：餘額卡、最快到期批次、點數紀錄是三套不同的渲染路徑。
export default class extends Controller {
  static targets = ['input', 'submit', 'success', 'error']

  static values = {
    url: String,
    successMessage: String,
    errorMessages: Object
  }

  static RELOAD_DELAY_MS = 1500

  async claim(event) {
    event.preventDefault()

    const code = this.inputTarget.value.trim()
    // 空白不送：API 會把它當成「碼不存在」計入錯誤次數
    if (!code || this.submitTarget.disabled) return

    this.submitTarget.disabled = true
    this.hideMessages()

    try {
      const response = await fetch(this.urlValue, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.content
        },
        credentials: 'same-origin',
        body: JSON.stringify({ code })
      })
      const body = await response.json().catch(() => ({}))

      if (response.ok && body.data) {
        this.show(this.successTarget, this.successMessageValue.replaceAll('%{amount}', body.data.amount))
        setTimeout(() => window.location.reload(), this.constructor.RELOAD_DELAY_MS)
        return
      }

      this.showError(body.error)
    } catch (error) {
      console.error('Coin code claim failed:', error)
      this.showError(null)
    }

    this.submitTarget.disabled = false
  }

  showError(errorCode) {
    const messages = this.errorMessagesValue
    this.show(this.errorTarget, messages[errorCode] || messages.default)
  }

  show(target, text) {
    target.textContent = text
    target.classList.remove('hidden')
  }

  hideMessages() {
    this.successTarget.classList.add('hidden')
    this.errorTarget.classList.add('hidden')
  }
}
